export class Rol {
    idRol: number;
    clave: string;
    descripcion: string;
    isChecked: boolean;
}


// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/core/model/classes/rol.ts